import { useEffect } from "react";
import { FormikErrors } from "formik";
import { extractFormikErrors } from "../common/toastMessage/toastHelper";
import { toast } from "react-toastify";

type FieldError = {
  field: string;
  message: string;
};

export const useToastMessage = <T>(
  isSubmitting: boolean,
  errors: FormikErrors<T>,
  scrollOffset = 200
): void => {
  useEffect(() => {
    const scrollToField = (fieldName: string) => {
      const fieldToScroll = `[fieldName="${fieldName}"]`;
      const fieldElement =
        document.querySelector(fieldToScroll) ||
        document.querySelector(`[name="${fieldName}"]`);

      if (fieldElement) {
        const elementTop = fieldElement.getBoundingClientRect().top;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const offset = elementTop + scrollTop - scrollOffset;

        window.scrollTo({
          top: offset,
          behavior: "smooth",
        });
      }
    };

    if (isSubmitting && Object.keys(errors).length > 0) {
      const errorMsgs: FieldError[] = extractFormikErrors(errors);

      errorMsgs.forEach((err) =>
        toast.error(err.message, {
          closeOnClick: false,
          toastId: err.field,
          onClick: () => {
            scrollToField(err.field);
          },
        })
      );
    } else if (isSubmitting && Object.keys(errors).length === 0) {
      toast.dismiss();
    }
  }, [isSubmitting, errors, scrollOffset]);
};
